import { useCallback, useEffect, useState } from "react";
import { storage } from "@/lib/storage";
import { trackEvent } from "@/lib/analytics";
import { dayNumber } from "@/lib/daily";

const KEY = "atlas.passport";
const EVENT = "atlas:passport";
export const BADGES = [
  { id: "explorer", min: 5 },
  { id: "traveller", min: 12 },
  { id: "connoisseur", min: 18 },
  { id: "master", min: 23 },
];

const read = () => {
  const v = storage.getJSON(KEY, {});
  return v && typeof v === "object" && !Array.isArray(v) ? v : {};
};

export const badgeFor = (count) => [...BADGES].reverse().find((b) => count >= b.min) || null;
export const nextBadge = (count) => BADGES.find((b) => count < b.min) || null;

/** Stamps = { CODE: dayNumber } for every country the visitor has opened. */
export function usePassport() {
  const [stamps, setStamps] = useState(read);

  useEffect(() => {
    const sync = () => setStamps(read());
    window.addEventListener(EVENT, sync);
    window.addEventListener("storage", sync);
    return () => { window.removeEventListener(EVENT, sync); window.removeEventListener("storage", sync); };
  }, []);

  /** Returns { isNew, count, badge } — badge only set when this stamp unlocked a new one. */
  const stamp = useCallback((code) => {
    const current = read();
    if (current[code]) return { isNew: false, count: Object.keys(current).length, badge: null };
    const next = { ...current, [code]: dayNumber() };
    storage.setJSON(KEY, next);
    window.dispatchEvent(new Event(EVENT));
    const count = Object.keys(next).length;
    const badge = BADGES.find((b) => b.min === count) || null;
    trackEvent("passport_stamp", { country_code: code, count });
    if (badge) trackEvent("passport_badge", { badge: badge.id });
    return { isNew: true, count, badge };
  }, []);

  return { stamps, count: Object.keys(stamps).length, stamp };
}
